import { RootState } from "src/store/types";

export const quotationsFclSelector = (state: RootState) => state.quotationsFcl;
export const fclLoadingSelector = (state: RootState) =>
  state.quotationsFcl.loadingFcl;
